const defaultTranslations = {
    'label.off': '{n}%',
    'label.bonus': '+{n}%BONUS',
    timer: '{time} left',
    getFreeItem: 'GET FREE',
};
export default defaultTranslations;
